// Render the loading / error / idle status line.

const el = () => document.getElementById('status');

export function setLoading(message) {
  const node = el();
  if (!node) return;
  node.className = 'status status--loading';
  node.textContent = message;
}

export function setError(message) {
  const node = el();
  if (!node) return;
  node.className = 'status status--error';
  node.textContent = message;
}

export function setIdle(message) {
  const node = el();
  if (!node) return;
  node.className = 'status status--idle';
  node.textContent = message;
}

export function clearStatus() {
  const node = el();
  if (!node) return;
  node.className = 'status';
  node.textContent = '';
}
